import StatusChip from "../../components/statusChip/statusChip.component";
import ActionButton from "../../components/tableActions/tableActions.component";
import {
  STATUS_COLORS,
  STATUS_TRANSLATIONS,
} from "../../utils/statusConstants";
import { actionsButtonsContainerSx } from "../../styles/commonStyles";
import { formattedDate } from "../../utils/dateUtils";

export const createRowsData = (data) => {
  return {
    id: data?.id,
    company_name: data?.company_name,
    fields: data?.fields || "N/A",
    date_joined: formattedDate(data?.date_joined),
    email: data?.email,
    status: STATUS_TRANSLATIONS[data?.status] || data?.status,
  };
};

export const companyColumns = (companyActions) => [
  { field: "id", headerName: "ID" },
  {
    field: "company_name",
    headerName: "Ragione sociale",
    flex: 0.25,
    minWidth: 250,
  },
  { field: "fields", headerName: "Terreni", flex: 0.12, minWidth: 100 },
  {
    field: "date_joined",
    headerName: "Data iscrizione",
    flex: 0.15,
    minWidth: 130,
  },
  { field: "email", headerName: "Email", flex: 0.3, minWidth: 250 },
  {
    field: "status",
    headerName: "Stato",
    flex: 0.12,
    minWidth: 100,
    renderCell: (params) => (
      <StatusChip status={params.value || "default"} colors={STATUS_COLORS} />
    ),
  },
  {
    field: "actions",
    headerName: "Azioni",
    flex: 0.06,
    minWidth: 150,
    renderCell: (params) => (
      <div style={actionsButtonsContainerSx}>
        {companyActions(params.row.status).map((item, index) => {
          return (
            <ActionButton
              key={index}
              icon={item.icon}
              tooltip={item.tooltip}
              onClick={() => item.onClick(params.row.id)}
            />
          );
        })}
      </div>
    ),
  },
];
